// ContactusLogic.js
import api from "@/assets/js/api"; // 引入 api
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於提示訊息

export default {
  data() {
    return {
      formData: {
        name: "", // 用戶輸入的姓名
        email: "", // 用戶輸入的電子郵件
        phone: "", // 用戶輸入的手機號碼
        message: "", // 用戶輸入的留言
      },
    };
  },
  methods: {
    async handleRegister() {
      // 檢查是否所有欄位都已填寫
      if (
        !this.formData.name ||
        !this.formData.email ||
        !this.formData.phone ||
        !this.formData.message
      ) {
        Swal.fire({
          icon: "warning", // 顯示警告圖示
          title: "欄位未填寫完整", // 標題
          text: "所有欄位均為必填，請完整填寫後再送出！", // 內容文字
          confirmButtonText: "確定", // 按鈕文字
        });
        return;
      }

      // 檢查電子郵件格式是否正確
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.formData.email)) {
        Swal.fire({
          icon: "error",
          title: "格式錯誤",
          text: "請輸入正確的電子郵件格式！",
          confirmButtonText: "確定",
        });
        return;
      }

      // 檢查手機號碼是否為數字且長度正確
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(this.formData.phone)) {
        Swal.fire({
          icon: "error",
          title: "格式錯誤",
          text: "請輸入正確的手機號碼！必須是 10 位數字。",
          confirmButtonText: "確定",
        });
        return;
      }

      try {
        // 發送 POST 請求
        const response = await api.post("/ContactUs", this.formData);

        // 處理後端回應
        console.log("後端回應：", response.data);
        Swal.fire({
          icon: "success", // 成功圖示
          title: "感謝您的聯絡", // 標題
          text: "我們會盡快回覆您！", // 內容文字
          confirmButtonText: "確定",
        });

        // 清空表單
        this.clearForm();
      } catch (error) {
        console.error("發送請求失敗：", error);
        Swal.fire({
          icon: "error", // 錯誤圖示
          title: "提交失敗", // 標題
          text: "請稍後再試！", // 錯誤內容
          confirmButtonText: "確定",
        });
      }
    },

    // 清空表單資料
    clearForm() {
      this.formData = {
        name: "",
        email: "",
        phone: "",
        message: "",
      };
    },
  },
};
